import { useState, useEffect } from "react";
import { ProfileService } from "../services/ProfileService";
import { AccountInfo, InteractionRequiredAuthError, InteractionStatus, IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

export const useProfileData = (
    inProgress: InteractionStatus, 
    instance: IPublicClientApplication
) => {
  
  const [profileData, setProfileData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
          const profileService = new ProfileService(); 

          const fetchProfileData = async () => {
            if (inProgress === InteractionStatus.None) {
              setIsLoading(true);
              try {
                const profileData = await profileService.getProfileData(instance);
                setProfileData(profileData);
              } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                  instance.acquireTokenRedirect({
                    ...loginRequest,
                    account: instance.getActiveAccount() as AccountInfo,
                  });
                }
                console.error("Error fetching tile data:", error);
              } finally {
                setIsLoading(false);
              }
            }
          };

          fetchProfileData();
        }, [inProgress, instance]);


  return { profileData, isLoading };
}
